import React from "react";
import BlueHeading from "../other/common/BlueHeading";
import Heading from "../common/ui/Heading";
import earth from "../../assets/images/png/earth.png";

const JeenaSikho = () => {
  return (
    <>
      <div className="bg-[#072152] px-4 ">
        <div className="max-w-[1140px] mx-auto ">
          <div className="flex md:justify-between justify-center items-center gap-10 xl:gap-16 sm:min-h-[500px] py-20">
            <div className="hidden md:block">
              <img className="w-full" src={earth} alt="earth" />
            </div>
            <div className="md:max-w-[423px] w-full ml-auto">
              <BlueHeading
                lineClassOne="!bg-white"
                lineClassTwo="!bg-white"
                text="Global Reach"
                textClass="!text-white"
              />
              <Heading
                children="Jeena Sikho Partnership: A Global Reach"
                className="text-white py-5 md:py-3"
              />
              <p className="text-base font-normal leading-[150%] text-[#FDFDFD]">
                Through our strategic partnership with Jeena Sikho, we are
                expanding our reach to a global audience. Jeena Sikho’s vast
                network and expertise in wellness and lifestyle management will
                play a key role in introducing Makeway's innovative products to
                customers worldwide. Together, we aim to create a positive
                impact by promoting a sustainable, healthy lifestyle.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default JeenaSikho;
